<app-spinner [isEnable]="!(processAppraiseeApproval$ | async)" loaderClass="confirmation-spinner-loader"></app-spinner>
<div class="base-shadow-list b-0" *ngIf="processAppraiseeApproval$ | async as  processAppraiseeApproval" [ngClass]="{'card m-b-10':processAppraiseeApproval.length > 0}">
    <div *ngIf="processAppraiseeApproval.length > 0; else emptyTemplate">
        <div class="card-body" *ngFor="let appraiseeApproval of getProcessAppraiseeApprovals(processAppraiseeApproval)">
            <div class="row">
                <div class="col-5 pr-0">
                    <div>
                        <span class="caption">{{ 'lang.user.appraisee' | translate}}:</span>
                        <span class="font-weight-bold">{{appraiseeApproval.appraisee.displayName}}</span>
                    </div>
                    <div>
                        <span class="caption">{{ 'lang.common.startDate' | translate}}:</span>
                        <span>{{ appraiseeApproval.startDate | date: 'MMMM dd, yyyy' }}</span>
                    </div>
                </div>
                <div class="col-5">
                    <div>
                        <span class="caption">{{ 'lang.common.process' | translate }}:</span>
                        <span>{{appraiseeApproval.processName }}</span>
                    </div>
                    <div>
                        <span class="caption">
                            {{ 'lang.common.processTypes' | translate }}:
                        </span>
                        <span *ngFor="let item of getProcessTypes(appraiseeApproval.processKnownTypes) as types; let i = index">
                            {{ item }}
                            <span *ngIf="i < types.length-1">, </span>
                        </span>
                    </div>
                </div>
                <div class="col-2 pl-0 text-right">
                    <span *ngIf="getIsApprovalTab()" class="btn-view" (click)="navigateToConfirm(appraiseeApproval)">{{ 'lang.common.btn.assignRespondents' | translate }}</span>
                    <span *ngIf="isMyPageEstimateTab" class="btn-view" (click)="navigateToReport(appraiseeApproval)">{{ 'lang.common.btn.assignRespondents' | translate }}</span>
                    <span *ngIf="isMyTeamSurveyTab&&!isMyPageEstimateTab" class="btn-download-report" (click)="navigateToReport(appraiseeApproval)">{{ 'lang.reporting.downloadReport' | translate }}</span>
                    <span *ngIf="isMyBUSurveyTab&&!isMyPageEstimateTab" class="btn-download-report" (click)="navigateToReportFromBu(appraiseeApproval)">{{ 'lang.reporting.downloadReport' | translate }}</span>
                </div>
            </div>
        </div>

    </div>
</div>
<ng-template #emptyTemplate>
    <div class="card b-0 base-shadow-list m-b-10">
        <div class="card-body pt-0">
            <div class="row">
                <div class="col-12 no-respondents d-flex align-items-center justify-content-center">
                    <span *ngIf="requirementType === viewRequirementType.ByAppraisee">
                        {{ 'lang.approval.emptyMyPage' | translate }}
                    </span>
                    <span *ngIf="requirementType === viewRequirementType.ByPerformanceManager">
                        {{ 'lang.approval.emptyPMPage' | translate }}
                    </span>
                    <span *ngIf="requirementType === viewRequirementType.ByDepartmentAdministrator">
                        {{ 'lang.approval.emptyHRPage' | translate }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</ng-template>